import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Link, Tooltip } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React, { useEffect } from "react";
import "../GroupHealthPolicy/GroupHealthPolicyEmpV2.scss";
import { useNavigate } from "react-router-dom";
import SearchBox from "../../../../../Components/Broker/SearchBarAnimation/SearchBox";

function GroupHealthPolicyEmpV2() {
  const navigate = useNavigate();

  const policyCover = [
    {
      title: "Apollo Benefits",
      featureName: "OPD Benefits",
      featureValue: "Up to 25% discount on OPD and in-house investigations.",
      descHeading: "Description:",
      descValue: "Discount on OPD expenses",
    },
    {
      title: "",
      featureName: "Retail Health Checkup",
      featureValue: "Up to 20% discount on Retail Health check-up packages.",
      descHeading: "Description:",
      descValue: "Discount on Retail Health Checkups",
    },
    {
      title: "",
      featureName: "Green Channel Entry",
      featureValue: "Green Channel Entry for all Members",
      descHeading: "Description:",
      descValue: "Benefits of Green Channel Entry",
    },
    {
      title: "",
      featureName: "Corporate Lounge",
      featureValue: "Corporate Lounge Access for Health Checkups",
      descHeading: "Description:",
      descValue: "Corporate Lounge Access Benefits",
    },
    {
      title: "",
      featureName: "Advantage Desk",
      featureValue: "End to End Services through Advantage Desk Facilities",
      descHeading: "Description:",
      descValue: "Benefits of Advanbtage Desk Facilities",
    },
  ];
  const coveredMember = [
    {
      img_url: "./images/father_img.svg",
      heading: "Rahul Raghuvanshi",
    },
    {
      img_url: "./images/mother_img.svg",
      heading: "Shivani Raghuvanshi",
    },
    {
      img_url: "./images/girl_img.svg",
      heading: "Galcy Raghuvanshi",
    },
    {
      img_url: "./images/boy_img.svg",
      heading: "Devansh Raghuvanshi",
    },
  ];
  const exclusionContent = [
    {
      exclusion_name: "STD",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "AIDS",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Ectopic Pregnancy",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Hepatitis C",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
    {
      exclusion_name: "Rabies",
      exclusion_para:
        "Expenses arising out of the above mentioned Disease/Illness/Condition/Procedure are not covered under this policy. ",
    },
  ];

  const hospital_table_data = [
    {
      hospital_name: "Save Sight Centre",
      hospital_address:
        "A-14, G.T. Karnal Road, Adarsh Nagar, Near Adarsh Nagar Metro Station",
      hospital_city: "Ambala - 133001",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Dhawan Orthopaedic Hospital",
      hospital_address: "Arya Nagar, Jagadhri Road, Ambala Cantt-133001",
      hospital_city: "Ambala - 134003",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Life Line Care Multi Speciality Hospital",
      hospital_address: "By Pass Road Yamuna Nagar",
      hospital_city: "Ambala - 135001",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Monga Hospital And Stone Centre",
      hospital_address: "Mahesh Nagar,jagadhri Road",
      hospital_city: "Ambala - 134003",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Save Sight Centre",
      hospital_address:
        "A-14, G.T. Karnal Road, Adarsh Nagar, Near Adarsh Nagar Metro Station",
      hospital_city: "Ambala - 133001",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Save Sight Centre",
      hospital_address:
        "A-14, G.T. Karnal Road, Adarsh Nagar, Near Adarsh Nagar Metro Station",
      hospital_city: "Ambala - 133001",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Dhawan Orthopaedic Hospital",
      hospital_address: "Arya Nagar, Jagadhri Road, Ambala Cantt-133001",
      hospital_city: "Ambala - 134003",
      hospital_state: "Haryana",
    },
    {
      hospital_name: "Life Line Care Multi Speciality Hospital",
      hospital_address: "By Pass Road Yamuna Nagar",
      hospital_city: "Ambala - 135001",
      hospital_state: "Haryana",
    },
  ];
  return (
    <Box className="grouppolicy_wrapper">
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={4} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate(-1);
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Group Health Insurance Policy</h3>
          </div>
        </Grid>
        <Grid
          xs={8}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
          }}
        >
          <Link underline="none" className="blueBtn edit">
            Endorsement
          </Link>
          <Link underline="none" className="blueBtn addfile">
            Add Member
          </Link>
          <Link underline="none" className="blueBtn download">
            E- Card
          </Link>
          <Link underline="none" className="blueBtn docs">
            Claim Request
          </Link>
        </Grid>
      </Grid>
      <div className="main_wrapper">
        <Grid container spacing={3}>
          <Grid xs={12} md={12} lg={6} className="left_section">
            <h5>
              Policy <span>#PROHL96839463</span>
            </h5>
            <div className="coverage_section">
              <ul>
                <li>
                  <img
                    src="./images/insurerlogo/digit.svg"
                    alt=""
                    height={57}
                  />
                </li>
                <li>
                  Sum Insured <span>₹ 10 Lakh</span>
                </li>
                <li className="text-right">
                  Coverage for
                  <span>2 Adults & 2 Children</span>
                </li>
              </ul>
            </div>
            <div className="policycover_section">
              <Grid container spacing={3}>
                <Grid xs={12} className="pl-0">
                  <h5>Covered Members:</h5>
                  <ul className="policycover">
                    {coveredMember.map((data, index) => (
                      <li>
                        <img src={data.img_url} />
                        {data.heading}
                      </li>
                    ))}
                  </ul>
                </Grid>
                <Grid xs={12} className="pl-0">
                  <h5>This Policy Covers:</h5>
                  <ul className="category_name">
                    {policyCover.map((data, index) => (
                      <li>
                        <h5>{data.title}</h5>
                        <h6 style={{ color: "#2166AA", fontWeight: 700 }}>
                          {data.featureName}
                        </h6>
                        <p>{data.featureValue}</p>
                        <p>
                          {data.descHeading} <span>{data.descValue}</span>
                        </p>
                      </li>
                    ))}
                  </ul>
                </Grid>
              </Grid>
            </div>
            <div className="exclusion">
              <h5>Exclusions:</h5>
              <ul className="exclusion_content">
                {exclusionContent.map((data, index) => (
                  <>
                    <h6 style={{ fontWeight: 700 }}> {data.exclusion_name}</h6>
                    <li> {data.exclusion_para}</li>
                  </>
                ))}
              </ul>
            </div>
          </Grid>
          <Grid xs={12} md={12} lg={6} className="right_section">
            <h4>Cashless Network Hospital List</h4>
            <Grid container spacing={3}>
              <Grid xs={12} className="text-center pt-0">
                <SearchBox />
              </Grid>
              <Grid xs={12}>
                <div className="table">
                  <div
                    className="hospital_table"
                    style={{ overflow: "hidden" }}
                  >
                    <ul className="heading">
                      <li>Hospital Name / Address</li>
                      <li>City - Pincode / State</li>
                    </ul>

                    {hospital_table_data.map((data, index) => (
                      <ul className="subheading">
                        <li>
                          {data.hospital_name}{" "}
                          <span>{data.hospital_address}</span>
                        </li>
                        <li>
                          {data.hospital_city}
                          <span>{data.hospital_state}</span>
                        </li>
                      </ul>
                    ))}
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

export default GroupHealthPolicyEmpV2;
